module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_8004.fdf6cac4.png";